import React, { useCallback, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import { useRoute } from "../hooks/useRoute";
import MainMenu from "../components/menu/MainMenu";
import ifAuthenticated from "../utils/hoc/ifAuthenticated";
import MobileView from "./MobileView/MobileView";
import { useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "../redux-stores/store";
import { useDispatch } from "react-redux";
import { setSelectedPost, setSelectedSocialPost, toggleAddSocialAccountModal, toggleLocationUpdateModal, toggleMainMenu, toggleProfileUpdateModal } from "../redux-stores/slices/layoutSlice";
import UpdateProfile from "../components/profile/UpdateProfile";
import { ConfirmationProvider } from "../contexts/ConfirmationContext";
import InfluencerPost from "../components/influencer/InfluencerPost";
import ifAccountConnected from "../utils/hoc/ifAccountConnected";
import withSlideUpModal from "../utils/hoc/withSlideUpModalComponent";
import usePageTracking from "../hooks/usePageTracking";
import { LocationProvider, useLocationAccess } from "../contexts/LocationContext";
import { registerPushDevice } from "../lib/registerPushNotifications";
import InfluencerSocialPost from "../components/influencer/InfluencerSocialPost";
import UpdateLocation from "../components/profile/UpdateLocation";
import AddSocialAccount from "../components/profile/AddSocialAccount";
import EnableDeviceLocationModal from "../components/location/EnableDeviceLocationModal";
import AppLocationPermissionModal from "../components/location/AppLocationPermissionModal";
import GetMobileApp from "../overlays/GetMobileApp";
import { analyticsSetUser, analyticsSetUserProperties } from "../lib/analytics";
import { useFirebase } from "../contexts/FirebaseContext";
import { startChatRealtime, stopChatRealtime } from "../redux-stores/slices/chatSlice";
import EnableNotificationsPopup from "../components/push-notification/EnableNotificationsPopup";
import HeaderNew from "../components/header/AppHeader";
import AppHeader from "../components/header/AppHeader";
import CreatorSocialPost from "../components/influencer/CreatorSocialPost";

const ProfileUpdateModal = withSlideUpModal(UpdateProfile);
const LocationUpdateModal = withSlideUpModal(UpdateLocation);
const AddSocialAccountModal = withSlideUpModal(AddSocialAccount, "", true);

const MainLayout: React.FC = () => {
    // const [menu, setMenu] = useState(false);
    const { 
        main_menu_visibility, 
        profile_update_modal_visibility, 
        location_update_modal_visibility, 
        page_title, selectedSocialPost, 
        bg_white, showFooterNav, showHeader,
        add_social_account_modal_visibility
    } = useSelector((state: RootState) => state.layout);
    const dispatch = useDispatch<AppDispatch>();
    const userId = useSelector((state: RootState) => state.auth.user?.uuid)
    const activePlan = useSelector((state: RootState) => state.influencer.active_plan);
    const socialAccounts = useSelector((state: RootState) => state.influencer.social_accounts);
    const profileCompletion = useSelector((state: RootState) => state.influencer.influencer?.profile_completion);

    const {db, firebaseUser} = useFirebase();
 

    useEffect(() => {
        if(socialAccounts.length < 1){
            setTimeout(() => {
                dispatch(toggleAddSocialAccountModal({active: true}))
            }, 2000)
        }

        analyticsSetUserProperties({
            ig_accounts: (socialAccounts ?? []).filter((acc) => acc.social_account.platform === 'ig').length,
            yt_accounts: (socialAccounts ?? []).filter((acc) => acc.social_account.platform === 'yt').length
        })

    }, [socialAccounts])

    useEffect(() => {
        if(socialAccounts.length > 0 && profileCompletion && profileCompletion < 100){
            setTimeout(() => {
                dispatch(toggleProfileUpdateModal(true))
            }, 2000)
        }
    }, [socialAccounts, profileCompletion])


    const currentRoute = useRoute();

    const hideMainMenu = () => {
        dispatch(toggleMainMenu(false));
    }

    useEffect(() => {
        if(userId){
            registerPushDevice();
            analyticsSetUser(userId)
        }
    }, [userId])

    useEffect(() => {
        if(activePlan){
            analyticsSetUserProperties({
                plan: activePlan?.plan?.name,
            })
        }
    }, [activePlan])


    useEffect(() => {
        if(db && firebaseUser){
            dispatch(startChatRealtime(db));
        }
        return () => {
            dispatch(stopChatRealtime());
        }
    }, [db, firebaseUser])


    return (
        <MobileView>
            <LocationProvider>
                <ConfirmationProvider>
                    <div className={`main-layout h-100 ${(bg_white || true) && 'bg-white'}`}>
                        {/* Header */}
                        {
                            showHeader &&
                            // <Header
                            //     title={currentRoute?.title ? currentRoute.title : (page_title ? page_title : '')}
                            //     menuToggleHandler={() => dispatch(toggleMainMenu(!main_menu_visibility))}
                            //     showBackButton={currentRoute?.showBackButton ?? false}
                            // />
                            <AppHeader />
                        }

                        {/* Main Content */}
                        <main className="min-full-screen" style={{ marginBottom: showFooterNav ? '65px' : '0px', paddingBottom: bg_white ? '0px' : '20px' }}>
                            <Outlet />
                        </main>

                        {/* Footer */}
                        {
                            showFooterNav && <Footer />
                        }

                        {/* Main Menu */}
                        <MainMenu visible={main_menu_visibility} hide={hideMainMenu} />

                        {/* Profile Update Modal */}
                        <ProfileUpdateModal
                            isActive={profile_update_modal_visibility}
                            onClose={() => dispatch(toggleProfileUpdateModal(false))}
                        />
                        <LocationUpdateModal
                            isActive={location_update_modal_visibility}
                            onClose={() => dispatch(toggleLocationUpdateModal(false))}
                        />
                        {/* <InfluencerPost
                            isActive={!!selected_post_id}
                            onClose={() => dispatch(setSelectedPost(null))}
                            postId={selected_post_id!}
                        /> */}
                        <CreatorSocialPost 
                            isActive={!!selectedSocialPost}
                            onClose={() => dispatch(setSelectedSocialPost(null))}
                            selectedSocialPost={selectedSocialPost!}
                        />

                        <AddSocialAccountModal
                            isActive={add_social_account_modal_visibility.active}
                            platforms={add_social_account_modal_visibility.platforms}
                            onClose={() => dispatch(toggleAddSocialAccountModal({active: false}))}
                        />

                        <EnableDeviceLocationModal />
                        <EnableNotificationsPopup />

                        <AppLocationPermissionModal />
                        <GetMobileApp />
                    </div >
                </ConfirmationProvider>
            </LocationProvider>
        </MobileView>
    );
};

export default ifAuthenticated(ifAccountConnected(MainLayout));